<div #ng1CardDetail class="hidden h-100">
    <sb-card-detail [menuItems]="menuItems"
                    [isRouted]="true"
                    [selectedValue]="{id: 'ng1Wrapper'}"
                    [actions]="actions"
                    [isLoadingMenuItems]="isLoadingMenuItems"
                    (onClickAction)="clickAction($event)"></sb-card-detail>
</div>
